import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    toggleWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',

        '& .MuiFormControlLabel-root': {
            margin: 0,
        },
    },
    tooltip: {
        background: theme.palette.neutral[100],
        color: theme.palette.text.primary,
        borderRadius: theme.dimensions.borderRadiusInput,
        opacity: 1,
        padding: theme.spacing(0.5, 1),
        fontSize: theme.typography.size.m,
    },
}));
